import { useState, type FormEvent } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Button, Input, Card } from '../../components/ui';
import styles from './Auth.module.css';

export function Signup() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { signUp } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Check if signing up as band manager
  const redirectTo = searchParams.get('redirect') || '/onboarding';
  const isAdminSignup = redirectTo === '/admin';

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setLoading(true);

    const { error } = await signUp(email, password);

    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      navigate(redirectTo);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <img src="/logo.png" alt="Mas Match" className={styles.logoImage} />
        <p className={styles.tagline}>
          {isAdminSignup ? 'Band Manager Signup' : 'Find your perfect band'}
        </p>
      </div>

      <Card className={styles.card}>
        <form onSubmit={handleSubmit} className={styles.form}>
          <h2 className={styles.title}>
            {isAdminSignup ? 'Create your manager account' : 'Create your account'}
          </h2>

          {error && <div className={styles.error}>{error}</div>}

          <Input
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
          />

          <Input
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="At least 6 characters"
            required
          />

          <Input
            label="Confirm Password"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirm your password"
            required
          />

          <Button type="submit" fullWidth loading={loading}>
            {isAdminSignup ? 'Create Manager Account' : 'Create Account'}
          </Button>

          <p className={styles.footer}>
            Already have an account?{' '}
            <Link to={isAdminSignup ? '/login?redirect=/admin' : '/login'}>Sign in</Link>
          </p>

          {!isAdminSignup && (
            <p className={styles.bandManager}>
              <Link to="/signup?redirect=/admin">Band Manager? Sign up here</Link>
            </p>
          )}

          {isAdminSignup && (
            <p className={styles.bandManager}>
              <Link to="/signup">Back to masquerader signup</Link>
            </p>
          )}
        </form>
      </Card>
    </div>
  );
}
